<template>
  <div class="builder-popup" ref="builderPopup">
    <!-- Sombrea el fondo -->
    <transition name="fade" mode="out-in">
      <div
        v-if="isVisible"
        class="overlay"
        ref="overlay"
        @click="closePopup"
      ></div>
    </transition>

    <!-- Popup -->
    <transition name="slide-up">
      <div
        v-if="isVisible"
        class="popup"
        :style="popupStyle"
        ref="popup"
      >
        <i class="sherpa-icon icon-cerrar" @click.stop="closePopup"></i>
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'builder-popup',
  props: {
    popupContainer: {
      type: HTMLElement, // Contenedor donde se debe mostrar el popup
      required: false
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      popupStyle: {},
      originalParent: null // Para restaurar la estructura del DOM al destruir el componente
    }
  },
  mounted () {
    if (this.popupContainer && this.$refs.builderPopup) {
      this.originalParent = this.$refs.builderPopup.parentNode // Guardamos el padre original
      this.popupContainer.appendChild(this.$refs.builderPopup) // Movemos el popup al contenedor deseado
    }
  },
  beforeUnmount () {
    if (this.originalParent && this.$refs.builderPopup) {
      this.originalParent.appendChild(this.$refs.builderPopup) // Restauramos el popup a su ubicación original
    }
  },
  methods: {
    closePopup () {
      this.$emit('popupVisibility', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.builder-popup {
  color: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.25);
    z-index: 999;
    transition: opacity 0.2s ease;
  }

  .popup {
    background-color: #e4fffe;
    border: 1px solid #666;
    box-shadow: 0 2px 10px rgba(150, 150, 150, 0.2);
    border-radius: 4px;
    opacity: 1;
    transition: opacity 0.2s ease, transform 0.2s ease;
    z-index: 1000;
    max-width: 80%;
    max-height: 90%;
    position: relative;

    i.icon-cerrar {
      position: absolute;
      top: 11px;
      right: 12px;
      font-size: 13px;
      transition: all 0.2s ease;
      color: #666;
      cursor: pointer;

      &:hover {
        color: #444;
      }
    }

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 10px;
      border: 3px solid #f1f1f1;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #555;
    }
  }

  /* Transiciones */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-up-enter-active, .slide-up-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
  }
  .slide-up-enter, .slide-up-leave-to {
    opacity: 0;
    transform: translateY(50px);
  }
}
</style>
